const mutateResourceTag = (resource, tag, operation) => {
  const tags = resource.tags.slice();
  const tagIndex = tags.findIndex((t) => t.id === tag.id);
  if (operation === "assign" && tagIndex === -1) {
    tags.push(tag);
  } else if (operation === "unassign" && tagIndex !== -1) {
    tags.splice(tagIndex, 1);
  }
  return {
    ...resource,
    tags
  };
};

export { mutateResourceTag };
//# sourceMappingURL=mutateResourceTag.js.map
